(function (app, ng) {

    app.provider("permissionService",
        [
            function () {
                this.$get = [
                    "_", function (_) {
                        return {
                            setPermissions: setPermissions,
                            hasAllPermissions: hasAllPermissions,
                            removeStoredPermissions: removeStoredPermissions
                        };

                        function setPermissions(permissions) {
                            localStorage.setItem("Auth.Permissions", JSON.stringify(permissions));
                        }

                        function getPermissions() {
                            return JSON.parse(localStorage.getItem("Auth.Permissions"));
                        }

                        function hasAllPermissions(permissions) {
                            var current = getPermissions();
                            var allowPermissions = _.filter(current,
                                function(row) {
                                    return row.Effect === "ALLOW";
                                });
                            var denyPermissions = _.filter(current,
                                function(row) {
                                    return row.Effect === "DENY";
                                });
                            var deny = false;
                            ng.forEach(permissions,
                                function (p) {
                                    var resource = p.split(":")[0];
                                    var action = p.split(":")[1];

                                    if (_.find(denyPermissions,
                                        function(d) {
                                            return _.find(d.Actions,
                                                function(a) {
                                                    return a.AllowAll === "*" || a.Resource === resource && a.Action === action;
                                                });
                                        }))
                                        deny = true;
                                });
                            if (deny)
                                return false;
                            if (_.find(allowPermissions,
                                function(row) {
                                    return _.find(row.Actions, function (act) { return act.AllowAll === "*"; });
                                }))
                                return true;
                            ng.forEach(permissions,
                                function(row) {
                                    var resource = row.split(":")[0];
                                    var action = row.split(":")[1];

                                    if (!_.find(allowPermissions,
                                        function(a) {
                                            return a.Resource === resource && a.Action === action;
                                        }))
                                        deny = true;
                                });
                            return !deny;
                        }

                        function removeStoredPermissions() {
                            localStorage.removeItem("Auth.Permissions");
                        }
                    }
                ];
            }
        ]);
})(window.app, window.angular); // jshint ignore:line